exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".produkt[data-v-5f28c9a5]{cursor:pointer}.produkt[data-v-5f28c9a5]:hover{text-decoration:none}.produkt .image-wrapper img[data-v-5f28c9a5]{border-radius:7px}.produkt .image-wrapper.img-lazy-load[data-v-5f28c9a5]{width:100%;height:0;padding-bottom:100%}.produkt .produkt-informationen[data-v-5f28c9a5]{padding:5px}.produkt .produkt-beschreibung h2[data-v-5f28c9a5]{color:#fff}.produkt .produkt-beschreibung p[data-v-5f28c9a5]{margin-bottom:0}.produkt .noselect[data-v-5f28c9a5]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
